<template>
  <div ref="container" class="categories-list">
    <div ref="carousel"
         class="categories-list__wrap"
    >
      <div :class="isTest ? '_test' : null"
           class="categories-list__inner"
      >
        <div v-if="icons.observation"
             class="categories-list__item _icon"
        >
          <BaseSvg name="ico-virus"/>
        </div>
        <div v-if="icons.housing"
             class="categories-list__item _icon"
        >
          <BaseSvg name="ico-house"/>
        </div>
        <div v-if="icons.meals"
             class="categories-list__item _icon"
        >
          <BaseSvg name="ico-cutlery"/>
        </div>
        <div v-if="icons.transport"
             class="categories-list__item _icon"
        >
          <BaseSvg name="ico-transport"/>
        </div>
        <div v-if="icons.clothes"
             class="categories-list__item _icon"
        >
          <BaseSvg name="ico-t-shirt"/>
        </div>

        <!-- TO SHOW -->
        <router-link-modified v-for="category in categoriesToShow"
                              :key="category.id"
                              :to="{name: 'vacancies', query: {direction: category.slug}}"
                              ref="categories"
                              class="categories-list__item"
        >
          <span>{{category.title}}</span>
        </router-link-modified>

        <!-- TO HIDE -->
        <template v-if="isShowMore">
          <router-link-modified v-for="category in categoriesToHide"
                                :to="{name: 'vacancies', query: {direction: category.slug}}"
                                :key="category.id"
                                type="button"
                                class="categories-list__item"
          >
            <span>{{category.title}}</span>
          </router-link-modified>
        </template>

        <button v-if="isTest || categoriesToHide.length && !isShowMore"
                type="button"
                class="categories-list__item"
                ref="more"
                @click.prevent="onShowMore"
        >
          <span>Еще +{{categoriesToHide.length}}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper';

  export default {
    name: 'CategoriesList',
    props: {
      isMob: {
        type: Boolean,
        default: false
      },
      vacancy: Object
    },
    data() {
      return {
        swiper: null,
        timer: null,
        isShowMore: false,
        isTest: true,
        sliceCategoriesIndex: 100
      };
    },
    computed: {
      icons() {
        const vacancy = this.vacancy;

        return {
          observation: !!(vacancy.conditions_observation_housing || vacancy.conditions_observation_housing_type),
          housing: !!(vacancy.conditions_housing || vacancy.conditions_housing_type || vacancy.conditions_housing_description),
          meals: !!(vacancy.conditions_meals || vacancy.conditions_meals_type),
          transport: !!(vacancy.conditions_transport || vacancy.conditions_transport_type),
          clothes: !!(vacancy.conditions_clothes || vacancy.conditions_clothes_type)
        };
      },
      categoriesToShow() {
        return (this.vacancy.categories || []).slice(0, this.sliceCategoriesIndex);
      },
      categoriesToHide() {
        return (this.vacancy.categories || []).slice(this.sliceCategoriesIndex, 100);
      }
    },
    methods: {
      createSwiper() {
        this.swiper = new Swiper(this.$refs['carousel'], {
          wrapperClass: 'categories-list__inner',
          slideClass: 'categories-list__item',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          freeMode: true,
          init: false
        });
      },
      checkMob() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (this.isMob) {
            if (!this.swiper) {
              this.createSwiper();
            }
            this.swiper.init();
          } else {
            if (this.swiper) {
              this.swiper.destroy();
              this.swiper = null;
            }
          }

          this.checkCategoriesToShow();
        }, 200);
      },
      onShowMore() {
        this.isShowMore = true;
      },
      checkCategoriesToShow() {
        this.isShowMore = false;
        this.isTest = true;
        this.sliceCategoriesIndex = 100;

        setTimeout(() => {
          const categories = this.$refs['categories'];
          const container = this.$refs['container'];
          const more = this.$refs['more'];

          if (container.scrollWidth > container.offsetWidth) {
            const containerRight = container.getBoundingClientRect().right;
            const moreWidth = more.offsetWidth + 12;
            const rightBorder = containerRight - moreWidth;

            const index = categories.findIndex(category => {
              return category.$el.getBoundingClientRect().right > rightBorder;
            });


            if (typeof index === 'number') {
              this.sliceCategoriesIndex = index;
            }
          }

          this.isTest = false;
        }, 50);
      }
    },
    mounted() {
      this.checkMob();
      window.addEventListener('resize', this.checkMob);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkMob);
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }
  };
</script>

<style>

</style>
